import { SmartsparAd } from '@components/smartspar-ad/smartspar-ad';
import { Success } from '@components/success/success';
import { LinkType } from '@eika/link';
import { useLinks } from '@hooks/use-links';
import { useTranslation } from '@translations';

export const ApproverParentSuccessPage = () => {
    const { overview } = useLinks();
    const { success, backToOverview } = useTranslation();

    return (
        <Success
            header={success.approverParentSuccess.header}
            ingress={success.approverParentSuccess.ingress}
            href={overview.url}
            linkText={backToOverview}
            linkType={LinkType.BUTTON_STANDARD_NEGATIVE}
        >
            <SmartsparAd />
        </Success>
    );
};
